module.exports = __webpack_public_path__ + "static/media/IMG_4239.96246dbb.JPG";